// src/redux/reducers/dashboard.reducer.ts
import { createSlice } from '@reduxjs/toolkit';
import DashboardState from '../states/dashboard.state';
import {
    fetchSpasWithErrors,
    fetchSpasWithTempDifference,
    fetchSpasConnectedThisWeek,
    fetchSpasConnectedLastWeek,
    fetchSpasWithSbHours,
    fetchOnlineMovedSpas,
    fetchSpaLocations,
} from '../actions/dashboard.actions';

const initialState: DashboardState = {
    spasWithErrors: { spa_guids: null, error_counts:null, error_labels:null, loading: false, error: null },
    spasWithTempDifference: { spa_guids: null, loading: false, error: null },
    spasConnectedThisWeek: { spa_guids: null, loading: false, error: null },
    spasConnectedLastWeek: { spa_guids: null, loading: false, error: null },
    spasWithSbHours: { spa_guids: null, loading: false, error: null },
    onlineMovedSpas: { spa_guids: null, loading: false, error: null },
    spaLocations: { geojson: null, loading: false, error: null },
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        resetDashboardData: (state) => {
            state = initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            // Spas with errors
            .addCase(fetchSpasWithErrors.pending, (state) => {
                state.spasWithErrors.loading = true;
                state.spasWithErrors.error = null;
            })
            .addCase(fetchSpasWithErrors.fulfilled, (state, action) => {
                state.spasWithErrors.loading = false;
                state.spasWithErrors.spa_guids = action.payload.data.spa_guids;
                state.spasWithErrors.error_counts = action.payload.data.error_counts;
                state.spasWithErrors.error_labels = action.payload.data.error_labels;
            })
            .addCase(fetchSpasWithErrors.rejected, (state, action) => {
                state.spasWithErrors.loading = false;
                state.spasWithErrors.error = action.payload as string;
            })
        // Add similar cases for other actions...
            // spasWithTempDifference
            .addCase(fetchSpasWithTempDifference.pending, (state) => {
                state.spasWithTempDifference.loading = true;
                state.spasWithTempDifference.error = null;
            })
            .addCase(fetchSpasWithTempDifference.fulfilled, (state, action) => {
                state.spasWithTempDifference.loading = false;
                state.spasWithTempDifference.spa_guids = action.payload.data.spa_guids;
            })
            .addCase(fetchSpasWithTempDifference.rejected, (state, action) => {
                state.spasWithTempDifference.loading = false;
                state.spasWithTempDifference.error = action.payload as string;
            })
            // spasConnectedThisWeek
            .addCase(fetchSpasConnectedThisWeek.pending, (state) => {
                state.spasConnectedThisWeek.loading = true;
                state.spasConnectedThisWeek.error = null;
            })
            .addCase(fetchSpasConnectedThisWeek.fulfilled, (state, action) => {
                state.spasConnectedThisWeek.loading = false;
                state.spasConnectedThisWeek.spa_guids = action.payload.data.spa_guids;
            })
            .addCase(fetchSpasConnectedThisWeek.rejected, (state, action) => {
                state.spasConnectedThisWeek.loading = false;
                state.spasConnectedThisWeek.error = action.payload as string;
            })
            // spasConnectedLastWeek
            .addCase(fetchSpasConnectedLastWeek.pending, (state) => {
                state.spasConnectedLastWeek.loading = true;
                state.spasConnectedLastWeek.error = null;
            })
            .addCase(fetchSpasConnectedLastWeek.fulfilled, (state, action) => {
                state.spasConnectedLastWeek.loading = false;
                state.spasConnectedLastWeek.spa_guids = action.payload.data.spa_guids;
            })
            .addCase(fetchSpasConnectedLastWeek.rejected, (state, action) => {
                state.spasConnectedLastWeek.loading = false;
                state.spasConnectedLastWeek.error = action.payload as string;
            })
            // spasWithSbHours
            .addCase(fetchSpasWithSbHours.pending, (state) => {
                state.spasWithSbHours.loading = true;
                state.spasWithSbHours.error = null;
        })
        .addCase(fetchSpasWithSbHours.fulfilled, (state, action) => {
            state.spasWithSbHours.loading = false;
            state.spasWithSbHours.spa_guids = action.payload.data.spa_guids;
        })
        .addCase(fetchSpasWithSbHours.rejected, (state, action) => {
            state.spasWithSbHours.loading = false;
            state.spasWithSbHours.error = action.payload as string;
        })
        // onlineMovedSpas
        .addCase(fetchOnlineMovedSpas.pending, (state) => {
            state.onlineMovedSpas.loading = true;
            state.onlineMovedSpas.error = null;
        })
        .addCase(fetchOnlineMovedSpas.fulfilled, (state, action) => {
            state.onlineMovedSpas.loading = false;
            state.onlineMovedSpas.spa_guids = action.payload.meta.total;
        })
        .addCase(fetchOnlineMovedSpas.rejected, (state, action) => {
            state.onlineMovedSpas.loading = false;
            state.onlineMovedSpas.error = action.payload as string;
        })
        // spaLocations
        .addCase(fetchSpaLocations.pending, (state) => {
            state.spaLocations.loading = true;
            state.spaLocations.error = null;
        })
        .addCase(fetchSpaLocations.fulfilled, (state, action) => {
            state.spaLocations.loading = false;
            state.spaLocations.geojson = action.payload.data;
        })
        .addCase(fetchSpaLocations.rejected, (state, action) => {
            state.spaLocations.loading = false;
            state.spaLocations.error = action.payload as string;
        })
    },
});

export const { resetDashboardData } = dashboardSlice.actions;
export default dashboardSlice.reducer;